import { defineMessages, FormattedMessage } from 'dibs-react-intl';

const copy = defineMessages({
    iPhonesImg: {
        id: 'apps.iphone.iPhonesImg',
        defaultMessage: 'Stacked iPhone and iPad',
    },
});

const descriptionHeader = (
    <FormattedMessage
        id="apps.iphone.descriptionHeader"
        defaultMessage="Shop great design on-the-go"
    />
);

const description = (
    <FormattedMessage
        id="apps.iphone.description"
        defaultMessage="Browse expertly curated furniture, jewelry, fashion and fine art from the world’s most prestigious sellers and galleries. Plus, save your favorite pieces, view items in a room and message sellers directly from your device."
    />
);

const sendSms = <FormattedMessage id="apps.iphone.sendSms" defaultMessage="TEXT ME A LINK" />;

export default {
    ...copy,
    descriptionHeader,
    description,
    sendSms,
};
